/**
 * Semantic color tokens, one value set per theme. The Tailwind preset turns
 * them into CSS variables; the mini-cart MUI theme and the Storybook docs read
 * them directly. Change a theme here only.
 *
 * @typedef {'canvas' | 'surface' | 'surface-muted' | 'surface-strong' | 'surface-raised' | 'surface-inverse' | 'content' | 'content-muted' | 'content-subtle' | 'content-inverse' | 'line' | 'line-medium' | 'line-strong' | 'accent' | 'accent-hover' | 'accent-content' | 'link' | 'link-hover' | 'focus' | 'danger' | 'danger-surface' | 'positive' | 'positive-surface' | 'warning' | 'warning-surface' | 'overlay'} ColorToken
 * @typedef {Record<ColorToken, string>} ColorTokenValues
 * @type {{ light: ColorTokenValues, dark: ColorTokenValues }}
 */
module.exports = {
  light: {
    canvas: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-muted': '#F5F5F5',
    'surface-strong': '#E6E6E6',
    'surface-raised': '#FFFFFF',
    'surface-inverse': '#141414',
    content: '#141414',
    'content-muted': '#4C4C4C',
    'content-subtle': '#666666',
    'content-inverse': '#FFFFFF',
    line: '#E6E6E6',
    'line-medium': '#CCCCCC',
    'line-strong': '#A6A6A6',
    accent: '#3A5BC7',
    'accent-hover': '#4268E6',
    'accent-content': '#FFFFFF',
    link: '#3A5BC7',
    'link-hover': '#4268E6',
    focus: '#4268E6',
    danger: '#D3171E',
    'danger-surface': '#FBEAEA',
    positive: '#007D3A',
    'positive-surface': '#E8F5EB',
    warning: '#AB6400',
    'warning-surface': '#FEFBE9',
    overlay: 'rgba(0,0,0,0.5)',
  },
  dark: {
    canvas: '#141414',
    surface: '#1C1C1C',
    'surface-muted': '#262626',
    'surface-strong': '#262626',
    'surface-raised': '#2B2B2B',
    'surface-inverse': '#F5F5F5',
    content: '#FAFAFA',
    'content-muted': '#CCCCCC',
    'content-subtle': '#A6A6A6',
    'content-inverse': '#141414',
    line: '#3A3A3A',
    'line-medium': '#3A3A3A',
    'line-strong': '#666666',
    accent: '#3A5BC7',
    'accent-hover': '#4268E6',
    'accent-content': '#FFFFFF',
    link: '#9EB1FF',
    'link-hover': '#9EB1FF',
    focus: '#9EB1FF',
    danger: '#FF6B6B',
    'danger-surface': '#3A1517',
    positive: '#3AC561',
    'positive-surface': '#12301C',
    warning: '#EAB308',
    'warning-surface': '#30260A',
    overlay: 'rgba(0,0,0,0.7)',
  },
};
